module.exports = __webpack_public_path__ + "static/media/tick-icon.7cc59557.svg";